import { Component } from '@angular/core';
import {GrafanaEmbedComponent} from '../../grafana/grafana-embed';

@Component({
  selector: 'app-maritime',
  imports: [
    GrafanaEmbedComponent
  ],
  templateUrl: './maritime.html',
  styleUrl: './maritime.scss',
})
export class MaritimeComponent {
  grafanaMaritime =
    'https://rd.vigimare.simavi.ro/grafana/d/vigimare-maritime-activity/vigimare-maritime-activity' +
    '?orgId=1' +
    '&kiosk' +
    '&from=now-6h' +
    '&to=now' +
    '&refresh=30s';
}
